import {datasource} from 'alt-utils/lib/decorators';
import {seamlessImmutable, seamlessBootstrap} from 'epic-alt-utils';
import alt from 'epic-fortnite-react/alt';
import Immutable from 'seamless-immutable';

import StatsActions from '../actions/StatsActions';
import StatsSource from '../sources/StatsSource';

@datasource(StatsSource)
@seamlessImmutable
class StatsStore {
  constructor() {
    this.on('error', (error) => {
      console.error(error);
    });
    this.on('bootstrap', seamlessBootstrap.bind(this, null));
    const initialState = Immutable({
      platform: 'pc',
      playlist: 'solo',
      placement: '1',
      globalLeaderboard: {},
      playerStats: null,
      currentPlayer: null,
      loading: false,
      initLoading: true,
    });
    this.state = initialState;
    this.bindActions(StatsActions);
  }

  onRefreshLeaderboard() {
    if (!this.state.initLoading && this.state.loading) {
      return false;
    }
    this.getInstance().getGlobal({
      platform: this.state.platform,
      playlist: this.state.playlist,
      placement: this.state.placement,
    });
    return this.setState(
      this.state.merge({
        loading: true,
      })
    );
  }

  onUpdateGlobalPlatform(platform) {
    if (!this.state.initLoading && this.state.loading) {
      return false;
    }
    this.getInstance().getGlobal({
      platform,
      playlist: this.state.playlist,
      placement: this.state.placement,
    });
    return this.setState(
      this.state.merge({
        loading: true,
        platform,
      })
    );
  }

  onUpdateGlobalPlaylist(playlist) {
    if (!this.state.initLoading && this.state.loading) {
      return false;
    }
    this.getInstance().getGlobal({
      platform: this.state.platform,
      playlist,
      placement: this.state.placement,
    });
    return this.setState(
      this.state.merge({
        loading: true,
        playlist,
      })
    );
  }

  onUpdateGlobalPlacement(placement) {
    if (!this.state.initLoading && this.state.loading) {
      return false;
    }
    this.getInstance().getGlobal({
      platform: this.state.platform,
      playlist: this.state.playlist,
      placement,
    });
    return this.setState(
      this.state.merge({
        loading: true,
        placement,
      })
    );
  }

  onUpdateGlobalSuccess(response) {
    const newState = {
      loading: false,
      initLoading: false,
      error: null,
      globalLeaderboard: response.data,
    };
    this.setState(this.state.merge(newState));
  }

  onUpdateGlobalFailure(response) {
    const error = response.data && response.data.message;
    this.setState(
      this.state.merge({
        loading: false,
        initLoading: false,
        error,
      })
    );
  }

  onGetPlayerStats(displayName) {
    if (!this.state.initLoading && this.state.loading) return false;
    if (this.state.playerStats && this.state.currentPlayer === displayName) return false;
    this.getInstance().getPlayerStats({
      displayName,
    });
    return this.setState(
      this.state.merge({
        loading: true,
        playerStats: null,
        currentPlayer: displayName,
      })
    );
  }

  onGetPlayerStatsSuccess(response) {
    const newState = {
      loading: false,
      initLoading: false,
      error: null,
      playerStats: response.data,
    };
    this.setState(this.state.merge(newState));
  }

  onGetPlayerStatsFailure(response) {
    const error = response.data && response.data.message;
    this.setState(
      this.state.merge({
        loading: false,
        initLoading: false,
        error,
      })
    );
  }
}

export default alt.createStore(StatsStore, 'StatsStore');
